import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { getIndexImage, formatDate } from '../../ui-helpers';

const IndexListItem = ({
  lang, color, slug, title, mainImage, date, onClick, brief, isInner, edition,
}) => {
  const onIndex = document.querySelector('.main-wrapper').classList.contains('on-index');
  const image = getIndexImage(mainImage, onIndex);
  const style = {
    color,
  };
  const backgroundImage = {
    backgroundImage: `url(${image})`,
    paddingTop: '67.058823529412%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: color,
  };
  const FormattedHtml = () => ({ __html: brief });
  return (
    <li className="content-list__item">
      <Link
        to={lang === 'ar' ? `/ar${slug}?edition=${edition}` : `${slug}?edition=${edition}`}
        onClick={onClick}
        style={style}
        className="content-list__item__link"
      >
        <div
          style={backgroundImage}
          className="content-list__item__image"
        />
        <div className="content-list__content">
          <h3 className="content-list__item__title">
            {title}
          </h3>
          <datetime className="content-list__item__date" >{formatDate(date)}</datetime>
          {
            isInner ?
            null :
            <div className="content-list__brief" dangerouslySetInnerHTML={FormattedHtml()} />
          }
        </div>
      </Link>
    </li>
  );
};

export default IndexListItem;

IndexListItem.propTypes = {
  lang: PropTypes.string.isRequired,
  edition: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  mainImage: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  brief: PropTypes.string.isRequired,
  isInner: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./js/components/indexFold/IndexListItem.js